export const allowedExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "pdf", "svg"];

export const isImageOrPdf = (fileName: string) => {
    const extension = fileName.split(".").pop()?.toLowerCase();
    return allowedExtensions.includes(extension || "");
};
